import React, { useState } from "react";

import {
  ArrowRight,
  Box,
  CalendarDays,
  CheckCircle2,
  ChevronDown,
  ChevronUp,
  Cpu,
  ExternalLink,
  Factory,
  FileText,
  Gift,
  Lightbulb,
  MapPin,
  Package,
  Rocket,
  Sparkles,
  Users,
  Wrench,
} from "lucide-react";

import "./ProgramaMakerIndustria.css";
import PartnersRuler from "../components/PartnersRuler";

const EDITAL_PDF_URL =
  "/maker/edital-programa-do-maker-a-industria.pdf";

/*
 * O backend será conectado na próxima etapa.
 * Não deixar "" em um fetch real para não enviar
 * POST para /programadomakeraindustria.
 */
const FORM_ENDPOINT = "/api/maker/inscricoes";

const NOTAS_EQUIPES = {
  "Duo Maker": "9,2",
  "anna personalizados": "9,2",
  "DW Comunicação Visual": "9,2",
  "DMILA 3D": "9,1",
  "Lunar 3D": "9,1",
  "EDUCA3D": "9,0",
  "Steam 3D": "8,8",
  "BioModel 3D": "8,8",
  "Acreforma3d": "8,8",
  "Talk": "8,7",
  "Faccolab3D": "8,7",
  "Amazônia Maker": "8,5",
  "JoTa": "8,5",
  "Félix Arquitetura": "8,5",
  "POTY 3D": "8,3",
  "EquiPEI": "8,2",
  "Mad Hatter": "8,0",
  "BlueToys": "7,8",
  "Naútilos 3D": "7,8",
  "ADACTA": "7,7",
  "Basil": "7,6",
  "3D Acre": "7,5",
  "Tudo 3D": "7,0",
  "3d Labs - eco joias": "6,2",
  "ALFAMAX": "4,3",
};

const EQUIPES_APROVADAS = [
  "Duo Maker",
  "anna personalizados",
  "DW Comunicação Visual",
  "DMILA 3D",
  "Lunar 3D",
  "EDUCA3D",
  "Steam 3D",
  "BioModel 3D",
  "Acreforma3d",
  "Talk",
  "Faccolab3D",
  "Amazônia Maker",
  "JoTa",
  "Félix Arquitetura",
  "POTY 3D",
  "EquiPEI",
  "Mad Hatter",
  "BlueToys",
  "Naútilos 3D",
  "ADACTA",
  "Basil",
  "3D Acre",
  "Tudo 3D",
  "3d Labs - eco joias",
  "ALFAMAX",
];

const EMPTY_MEMBER = {
  nome: "",
  cpf: "",
  email: "",
  telefone: "",
  municipio: "",
  minicurriculo: "",
  habilidades: "",
};

const fases = [
  {
    numero: "01",
    titulo: "Descoberta, ideação e formatação",
    texto:
      "Identificação de problemas e oportunidades, pesquisa de usuário e mercado, benchmarking, design de produto, requisitos, proposta de valor, propriedade intelectual e planejamento de fabricação.",
    destaque: "Entregável: Ficha de Produto",
  },
  {
    numero: "02",
    titulo: "Modelagem, prototipagem e validação",
    texto:
      "Modelagem 3D, preparação para fabricação, prototipagem, testes, iterações e avaliação preliminar de custo e escala.",
    destaque: "Até 20 equipes seguem para esta fase",
  },
  {
    numero: "03",
    titulo: "Demonstração, pitch e DemoDay",
    texto:
      "Preparação da apresentação, demonstração dos protótipos e apresentação das soluções desenvolvidas durante a jornada.",
    destaque: "DemoDay e encerramento",
  },
];

const criterios = [
  ["01", "Complementaridade e organização da equipe", "2,0"],
  ["02", "Aptidão técnica e capacidade de aprendizagem", "2,0"],
  ["03", "Motivação e aderência à jornada", "2,0"],
  ["04", "Disponibilidade e compromisso", "2,0"],
  ["05", "Conexão com o contexto produtivo regional", "2,0"],
];

const faqs = [
  {
    pergunta: "Preciso ter um produto pronto?",
    resposta:
      "Não. O programa não exige produto previamente definido, projeto pronto ou protótipo no momento da inscrição. A definição do produto acontece durante a Fase 1.",
  },
  {
    pergunta: "Preciso saber modelagem 3D ou impressão 3D?",
    resposta:
      "Não. Experiência anterior poderá ser considerada na avaliação da aptidão técnica, mas não é requisito eliminatório.",
  },
  {
    pergunta: "Preciso ter CNPJ?",
    resposta:
      "Não. A existência de CNPJ não é requisito obrigatório para inscrição.",
  },
  {
    pergunta: "Quantas pessoas devem formar a equipe?",
    resposta:
      "Cada equipe poderá possuir de 1 a 3 integrantes. O primeiro integrante cadastrado será considerado o líder.",
  },
  {
    pergunta: "Pessoas de outros municípios do Acre podem participar?",
    resposta:
      "Sim. O programa é destinado ao Estado do Acre. Até 6 vagas serão prioritariamente destinadas a equipes cujo líder resida em município diferente de Rio Branco.",
  },
  {
    pergunta: "A bolsa de R$ 1.700 é para cada integrante?",
    resposta:
      "Não. O valor previsto é de até R$ 1.700 por equipe classificada para a Fase 2 e possui aplicação vinculada a materiais, insumos, peças e componentes do protótipo.",
  },
];

function MemberCard({
  index,
  member,
  updateMember,
  canRemove,
  removeMember,
}) {
  return (
    <div className="maker-member">
      <div className="maker-member-header">
        <div>
          <span className="maker-member-number">
            {String(index + 1).padStart(2, "0")}
          </span>

          <div>
            <small>
              {index === 0
                ? "LÍDER DA EQUIPE"
                : "INTEGRANTE"}
            </small>

            <h4>Integrante {index + 1}</h4>
          </div>
        </div>

        {canRemove && (
          <button
            type="button"
            className="maker-remove"
            onClick={() => removeMember(index)}
          >
            Remover
          </button>
        )}
      </div>

      <div className="maker-form-grid">
        <label className="maker-full">
          Nome completo *
          <input
            required
            value={member.nome}
            onChange={(e) =>
              updateMember(index, "nome", e.target.value)
            }
          />
        </label>

        <label>
          CPF *
          <input
            required
            inputMode="numeric"
            placeholder="000.000.000-00"
            value={member.cpf}
            onChange={(e) =>
              updateMember(index, "cpf", e.target.value)
            }
          />
        </label>

        <label>
          Município de residência *
          <input
            required
            value={member.municipio}
            onChange={(e) =>
              updateMember(
                index,
                "municipio",
                e.target.value
              )
            }
          />
        </label>

        <label>
          E-mail *
          <input
            required
            type="email"
            value={member.email}
            onChange={(e) =>
              updateMember(index, "email", e.target.value)
            }
          />
        </label>

        <label>
          WhatsApp / telefone *
          <input
            required
            type="tel"
            value={member.telefone}
            onChange={(e) =>
              updateMember(
                index,
                "telefone",
                e.target.value
              )
            }
          />
        </label>

        <label className="maker-full">
          Mini currículo *
          <textarea
            required
            rows="5"
            maxLength={1000}
            value={member.minicurriculo}
            onChange={(e) =>
              updateMember(
                index,
                "minicurriculo",
                e.target.value
              )
            }
          />
          <small>
            {member.minicurriculo.length}/1000 caracteres
          </small>
        </label>

        <label className="maker-full">
          Principais habilidades *
          <textarea
            required
            rows="4"
            value={member.habilidades}
            onChange={(e) =>
              updateMember(
                index,
                "habilidades",
                e.target.value
              )
            }
          />
        </label>
      </div>
    </div>
  );
}

function ProgramaMakerIndustria() {
  const [members, setMembers] = useState([
    { ...EMPTY_MEMBER },
  ]);

  const [faqOpen, setFaqOpen] = useState(null);
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [buscaEquipe, setBuscaEquipe] = useState("");
  const [paginaEquipes, setPaginaEquipes] = useState(1);

  const EQUIPES_POR_PAGINA = 10;

  const normalizarTexto = (valor) =>
    valor
      .normalize("NFD")
      .replace(/[\\u0300-\\u036f]/g, "")
      .toLowerCase()
      .trim();

  const equipesFiltradas = EQUIPES_APROVADAS.filter((nome) =>
    normalizarTexto(nome).includes(
      normalizarTexto(buscaEquipe)
    )
  );

  const totalPaginasEquipes = Math.max(
    1,
    Math.ceil(
      equipesFiltradas.length / EQUIPES_POR_PAGINA
    )
  );

  const inicioEquipes =
    (paginaEquipes - 1) * EQUIPES_POR_PAGINA;

  const equipesPagina = equipesFiltradas.slice(
    inicioEquipes,
    inicioEquipes + EQUIPES_POR_PAGINA
  );

  const pesquisarEquipe = (event) => {
    setBuscaEquipe(event.target.value);
    setPaginaEquipes(1);
  };

  const updateMember = (index, field, value) => {
    setMembers((current) =>
      current.map((item, itemIndex) =>
        itemIndex === index
          ? { ...item, [field]: value }
          : item
      )
    );
  };

  const addMember = () => {
    if (members.length >= 3) return;

    setMembers((current) => [
      ...current,
      { ...EMPTY_MEMBER },
    ]);
  };

  const removeMember = (index) => {
    if (members.length <= 1) return;

    setMembers((current) =>
      current.filter((_, i) => i !== index)
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!FORM_ENDPOINT) {
      setMessage(
        "O formulário está pronto. O recebimento das inscrições será conectado ao backend antes da abertura oficial."
      );

      setTimeout(() => {
        document
          .getElementById("maker-form-message")
          ?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
      }, 100);

      return;
    }

    try {
      setSending(true);
      setMessage("");

      const form = event.currentTarget;
      const raw = new FormData(form);

      const payload = {
        integrantes: members,
      };

      for (const [key, value] of raw.entries()) {
        if (value instanceof File) continue;

        if (
          Object.prototype.hasOwnProperty.call(
            payload,
            key
          )
        ) {
          if (!Array.isArray(payload[key])) {
            payload[key] = [payload[key]];
          }

          payload[key].push(value);
        } else {
          payload[key] = value;
        }
      }

      const outgoing = new FormData();

      outgoing.append(
        "payload",
        JSON.stringify(payload)
      );

      const portfolio = raw.get("portfolio");

      if (
        portfolio instanceof File &&
        portfolio.size > 0
      ) {
        outgoing.append(
          "portfolio",
          portfolio,
          portfolio.name
        );
      }

      const response = await fetch(FORM_ENDPOINT, {
        method: "POST",
        body: outgoing,
      });

      let data = {};

      try {
        data = await response.json();
      } catch {
        data = {};
      }

      if (!response.ok) {
        throw new Error(
          data.detail ||
            "Não foi possível enviar a inscrição."
        );
      }

      setMessage(
        `Inscrição enviada com sucesso! Seu protocolo é ${data.protocolo}. Guarde este número.`
      );

      form.reset();

      setMembers([
        { ...EMPTY_MEMBER },
      ]);
    } catch (error) {
      setMessage(
        error?.message ||
          "Não foi possível enviar a inscrição."
      );
    } finally {
      setSending(false);
    }
  };

  return (
    <main className="maker-page notranslate" translate="no">

      {/* HERO */}
      <section className="maker-hero">
        <div className="maker-decoration maker-decoration-top" />

        <div className="maker-container maker-hero-grid">
          <div className="maker-brand">

            <div className="maker-logo-symbol">
              <div className="maker-logo-blue">
                <span />
                <span />
                <span />
              </div>

              <div className="maker-logo-yellow" />

              <div className="maker-logo-orange">
                <div className="maker-nozzle" />
                <div className="maker-wave-logo">
                  ≋
                </div>
              </div>
            </div>

            <div className="maker-brand-copy">
              <span>
                PROGRAMA DE ACELERAÇÃO
              </span>

              <h1>
                Do <strong>Maker</strong>
                <br />
                à Indústria
              </h1>

              <div className="maker-tagline">
                MODELAGEM
                <i />
                PROTOTIPAGEM
                <i />
                INOVAÇÃO
              </div>
            </div>
          </div>

          <div className="maker-hero-info">
            <span className="maker-edital-label">
              EDITAL IMA Nº 02/2026
            </span>

            <h2>
              Da ideia ao
              <br />
              <strong>produto.</strong>
            </h2>

            <p>
              Uma jornada de formação, ideação,
              modelagem 3D, fabricação digital,
              prototipagem e desenvolvimento de
              soluções com potencial produtivo e de
              mercado.
            </p>

            <div className="maker-actions">
              <a
                href="#inscricao-maker"
                className="maker-btn maker-btn-orange"
              >
                Acessar resultado
                <ArrowRight />
              </a>

              <a
                href={EDITAL_PDF_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="maker-btn maker-btn-blue-outline"
              >
                Ler edital
                <ExternalLink size={17} />
              </a>
            </div>
          </div>
        </div>

        <div className="maker-wave-line">
          ∿∿∿∿∿∿∿∿∿∿∿∿∿
        </div>
      </section>

      {/* NÚMEROS */}
      <section className="maker-numbers">
        <div className="maker-container maker-numbers-grid">
          <div>
            <Users />
            <strong>40</strong>
            <span>equipes na Fase 1</span>
          </div>

          <div>
            <Package />
            <strong>2 a 3</strong>
            <span>integrantes por equipe</span>
          </div>

          <div>
            <Rocket />
            <strong>20</strong>
            <span>equipes na Fase 2</span>
          </div>

          <div>
            <Gift />
            <strong>R$ 1.700</strong>
            <span>até por equipe</span>
          </div>
        </div>
      </section>

      {/* SOBRE */}
      <section className="maker-section maker-about">
        <div className="maker-container maker-two-columns">
          <div>
            <span className="maker-kicker">
              SOBRE O PROGRAMA
            </span>

            <h2>
              Criar.
              <br />
              Modelar.
              <br />
              <strong>Construir.</strong>
            </h2>
          </div>

          <div className="maker-copy">
            <p>
              O Programa Do Maker à Indústria foi
              criado para aproximar makers, designers,
              estudantes, empreendedores, profissionais
              e o setor produtivo.
            </p>

            <p>
              A jornada acompanha as equipes na
              transformação de conhecimentos,
              experiências e oportunidades em conceitos
              de produto, modelos tridimensionais,
              protótipos e soluções.
            </p>

            <div className="maker-info-card">
              <Lightbulb />

              <div>
                <strong>
                  Não precisa chegar com uma ideia pronta.
                </strong>

                <p>
                  O produto será formulado e recortado
                  durante a primeira fase do programa.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* QUEM PARTICIPA */}
      <section className="maker-section maker-blue-section">
        <div className="maker-container">
          <span className="maker-kicker maker-kicker-yellow">
            QUEM PODE PARTICIPAR
          </span>

          <h2 className="maker-white-title">
            Diferentes conhecimentos.
            <br />
            <strong>Uma equipe.</strong>
          </h2>

          <div className="maker-requirements">
            {[
              "Equipes com 1 a 3 integrantes",
              "Indicação de uma pessoa líder",
              "Participantes residentes no Estado do Acre",
              "Disponibilidade para as atividades da jornada",
              "Pessoas físicas podem participar",
              "CNPJ não é obrigatório",
              "Experiência em impressão 3D não é obrigatória",
              "Não é necessário possuir produto pronto",
            ].map((item) => (
              <div key={item}>
                <CheckCircle2 />
                <span>{item}</span>
              </div>
            ))}
          </div>

          <div className="maker-acre-card">
            <MapPin />

            <div>
              <span>INTERIORIZAÇÃO</span>

              <strong>
                Até 6 vagas prioritárias para equipes
                de outros municípios do Acre.
              </strong>

              <p>
                A prioridade considera equipes cujo
                líder resida fora de Rio Branco.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* JORNADA */}
      <section className="maker-section maker-journey">
        <div className="maker-container">
          <span className="maker-kicker">
            JORNADA
          </span>

          <div className="maker-section-heading">
            <h2>
              Do maker
              <br />
              <strong>à indústria.</strong>
            </h2>

            <p>
              Três fases encadeadas para transformar
              problemas e oportunidades em soluções
              testáveis.
            </p>
          </div>

          <div className="maker-phases">
            {fases.map((fase) => (
              <article key={fase.numero}>
                <span className="maker-phase-number">
                  {fase.numero}
                </span>

                <div className="maker-phase-icon">
                  {fase.numero === "01" && (
                    <Lightbulb />
                  )}

                  {fase.numero === "02" && (
                    <Cpu />
                  )}

                  {fase.numero === "03" && (
                    <Factory />
                  )}
                </div>

                <h3>{fase.titulo}</h3>

                <p>{fase.texto}</p>

                <strong>
                  {fase.destaque}
                </strong>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* BOLSA */}
      <section className="maker-investment">
        <div className="maker-container maker-investment-grid">
          <div>
            <span className="maker-kicker maker-kicker-blue">
              ESTÍMULO À INOVAÇÃO
            </span>

            <h2>
              R$ <strong>1.700</strong>
            </h2>

            <h3>
              até por equipe classificada para a Fase 2
            </h3>

            <p>
              O incentivo deverá ser aplicado
              exclusivamente na aquisição de materiais,
              insumos, peças e componentes diretamente
              relacionados ao desenvolvimento do
              protótipo.
            </p>
          </div>

          <div className="maker-materials">
            {[
              "Filamentos e resinas",
              "Componentes eletrônicos",
              "Sensores e conectores",
              "Peças mecânicas",
              "MDF, acrílico e metais",
              "Materiais técnicos",
              "Tintas, colas e consumíveis",
              "Peças para montagem e testes",
            ].map((item) => (
              <div key={item}>
                <CheckCircle2 />
                {item}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SELEÇÃO */}
      <section className="maker-section maker-selection">
        <div className="maker-container">
          <span className="maker-kicker">
            PROCESSO SELETIVO
          </span>

          <h2>
            O que será
            <br />
            <strong>avaliado?</strong>
          </h2>

          <div className="maker-criteria">
            {criterios.map(
              ([numero, titulo, pontos]) => (
                <article key={numero}>
                  <span>{numero}</span>

                  <h3>{titulo}</h3>

                  <strong>
                    {pontos} pontos
                  </strong>
                </article>
              )
            )}
          </div>

          <div className="maker-score">
            <strong>
              10 pontos possíveis
            </strong>

            <span>
              Nota mínima: 6,0 pontos
            </span>
          </div>
        </div>
      </section>

      {/* CRONOGRAMA */}
      <section className="maker-section maker-timeline-section">
        <div className="maker-container">
          <span className="maker-kicker">
            DATAS IMPORTANTES
          </span>

          <h2>
            Cronograma
          </h2>

          <div className="maker-timeline">
            {[
              ["14/09", "Publicação do edital"],
              ["05 — 07/10", "Avaliação das inscrições"],
              ["08/10", "Resultado preliminar"],
              ["09 — 13/10", "Recursos"],
              ["16/10", "Resultado final e convocação"],
              ["19/10", "Abertura do programa e Fase 1"],
              [
                "23 — 26/10",
                "Ficha de Produto e Plano de Aplicação"
              ],
              [
                "27 — 28/10",
                "Avaliação para ingresso na Fase 2"
              ],
              [
                "05/11",
                "Resultado final das 20 equipes"
              ],
              [
                "06 — 20/11",
                "Fase 2 — modelagem e prototipagem"
              ],
              [
                "23 — 27/11",
                "Preparação da Fase 3"
              ],
              [
                "05/12",
                "DemoDay e encerramento"
              ],
            ].map(([date, title], index) => (
              <div
                className="maker-timeline-item"
                key={`${date}-${title}`}
              >
                <span>
                  {String(index + 1).padStart(2, "0")}
                </span>

                <strong>{date}</strong>

                <p>{title}</p>
              </div>
            ))}
          </div>

          <div className="maker-deadline-note">
            <CalendarDays />

            <p>
              A data de encerramento das inscrições será
              apresentada após a confirmação da versão
              final do cronograma oficial.
            </p>
          </div>
        </div>
      </section>

      {/* EDITAL */}
      <section className="maker-edital-banner">
        <div className="maker-container">
          <div>
            <span>
              EDITAL IMA Nº 02/2026
            </span>

            <h2>
              Leia o edital completo.
            </h2>

            <p>
              Confira regras, elegibilidade, etapas,
              critérios, propriedade intelectual e
              condições de participação.
            </p>
          </div>

          <a
            href={EDITAL_PDF_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="maker-btn maker-btn-blue"
          >
            <FileText />
            Acessar edital
            <ExternalLink size={17} />
          </a>
        </div>
      </section>

      {/* RESULTADO — EQUIPES APROVADAS */}
      <section
        id="inscricao-maker"
        className="maker-section maker-form-section"
        
      >
        <div className="maker-container">

          <div className="maker-form-heading maker-approved-heading">

            <span className="maker-kicker">
              RESULTADO
            </span>

            <h2>
              Ranking de<br /><strong>classificação.</strong>
            </h2>

            <p>
              Confira o ranking dos 25 projetos avaliados na primeira fase do
              <strong> Programa Do Maker à Indústria</strong>.
              Os 20 primeiros colocados foram classificados para a segunda fase.
            </p>

          </div>

          <div className="maker-approved-panel">

            <div className="maker-approved-search">

              <label htmlFor="busca-equipe">
                Pesquise sua equipe
              </label>

              <div className="maker-approved-search-box">

                <span aria-hidden="true">
                  ⌕
                </span>

                <input
                  id="busca-equipe"
                  type="search"
                  value={buscaEquipe}
                  onChange={pesquisarEquipe}
                  placeholder="Digite o nome da equipe..."
                  autoComplete="off"
                />

              </div>

            </div>

            <div className="maker-approved-summary">

              <strong>
                {equipesFiltradas.length}
              </strong>{" "}

              {equipesFiltradas.length === 1
                ? "projeto encontrado"
                : "projetos encontrados"}

            </div>

            {equipesPagina.length > 0 ? (
              <>

                
                
                
                <div className="maker-approved-list">

                  {equipesPagina.map((nome) => {

                    const posicao = EQUIPES_APROVADAS.indexOf(nome) + 1;
                    const classificada = posicao <= 20;

                    return (

                      <div
                        className="maker-approved-item"
                        key={nome}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: "12px",
                          width: "100%",
                          boxSizing: "border-box",
                          padding: "15px 8px",
                          borderBottom: "1px solid #e5e7eb",
                          background: classificada
                            ? "transparent"
                            : "#f9fafb"
                        }}
                      >

                        <span
                          className="maker-approved-number"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: classificada
                              ? "#dcfce7"
                              : "#e5e7eb",
                            color: classificada
                              ? "#166534"
                              : "#6b7280",
                            fontWeight: 800,
                            fontSize: "15px",
                            borderRadius: "9px",
                            minWidth: "44px",
                            height: "40px",
                            flexShrink: 0
                          }}
                        >
                          {String(posicao).padStart(2, "0")}
                        </span>

                        <span
                          className="maker-approved-name"
                          style={{
                            flex: "1 1 auto",
                            minWidth: 0,
                            fontWeight: 700,
                            color: classificada
                              ? "#082b63"
                              : "#6b7280",
                            overflowWrap: "anywhere"
                          }}
                        >
                          {nome}
                        </span>

                        {classificada && (

                          <span
                            className="maker-approved-status"
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "7px",
                              marginLeft: "auto",
                              padding: "9px 13px",
                              borderRadius: "10px",
                              background: "#dcfce7",
                              border: "1px solid #86efac",
                              color: "#166534",
                              fontWeight: 700,
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                              flexShrink: 0
                            }}
                          >

                            <CheckCircle2
                              size={17}
                              aria-hidden="true"
                            />

                            Classificado

                          </span>

                        )}

                      </div>

                    );

                  })}

                </div>

                {totalPaginasEquipes > 1 && (

                  <div className="maker-approved-pagination">

                    <button
                      type="button"
                      onClick={() =>
                        setPaginaEquipes((pagina) =>
                          Math.max(1, pagina - 1)
                        )
                      }
                      disabled={paginaEquipes === 1}
                    >
                      Anterior
                    </button>

                    <div className="maker-approved-pages">

                      {Array.from(
                        { length: totalPaginasEquipes },
                        (_, index) => index + 1
                      ).map((pagina) => (

                        <button
                          type="button"
                          key={pagina}
                          className={
                            paginaEquipes === pagina
                              ? "active"
                              : ""
                          }
                          onClick={() =>
                            setPaginaEquipes(pagina)
                          }
                          aria-current={
                            paginaEquipes === pagina
                              ? "page"
                              : undefined
                          }
                        >
                          {pagina}
                        </button>

                      ))}

                    </div>

                    <button
                      type="button"
                      onClick={() =>
                        setPaginaEquipes((pagina) =>
                          Math.min(
                            totalPaginasEquipes,
                            pagina + 1
                          )
                        )
                      }
                      disabled={
                        paginaEquipes ===
                        totalPaginasEquipes
                      }
                    >
                      Próxima
                    </button>

                  </div>

                )}

              </>
            ) : (

              <div className="maker-approved-empty">

                <strong>
                  Nenhuma equipe encontrada.
                </strong>

                <p>
                  Confira a escrita do nome e tente novamente.
                </p>

              </div>

            )}

          </div>

        </div>
      </section>

      {/* FAQ */}
      <section className="maker-section maker-faq">
        <div className="maker-container maker-two-columns">

          <div>
            <span className="maker-kicker">
              DÚVIDAS
            </span>

            <h2>
              Antes de
              <br />
              <strong>começar.</strong>
            </h2>
          </div>

          <div className="maker-faq-list">
            {faqs.map((item, index) => (
              <button
                type="button"
                key={item.pergunta}
                className="maker-faq-item"
                onClick={() =>
                  setFaqOpen(
                    faqOpen === index
                      ? null
                      : index
                  )
                }
              >
                <div>
                  <strong>
                    {item.pergunta}
                  </strong>

                  {faqOpen === index
                    ? <ChevronUp />
                    : <ChevronDown />}
                </div>

                {faqOpen === index && (
                  <p>{item.resposta}</p>
                )}
              </button>
            ))}
          </div>

        </div>
      </section>

      {/* FINAL */}
      <section className="maker-final">
        <div className="maker-final-circle" />

        <div className="maker-container">
          <Sparkles />

          <span>
            PROGRAMA DO MAKER À INDÚSTRIA
          </span>

          <h2>
            IDEIAS
            <br />
            <strong>GANHAM FORMA.</strong>
          </h2>

          <a
            href="#inscricao-maker"
            className="maker-btn maker-btn-yellow"
          >
            Inscrever equipe
            <ArrowRight />
          </a>

        </div>
      </section>

          <PartnersRuler />
    </main>
  );
}

export default ProgramaMakerIndustria;
